import { useDataProvider, useResourceContext } from 'react-admin';
import { useEffect, useState } from "react";
import InputFieldCustom from '../Commons/InputFieldCustom'
import { useMediaQuery } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import BreadCrumbCustom from '../Commons/BreadCrum';
import historyTracker from '../Commons/historyTracker';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import AuthNotification from '../Commons/AuthNotification';
import { Style } from '../Commons/Styles.jsx';
import BottomToolBar from '../Commons/BottomToolBar';
import InternalMenu from '../Commons/InternalMenu';
// TODO: reemplazar por el ícono definitivo de Proveedores cuando esté disponible
import providers from '../Commons/Icons/apps.svg';
import providerList from '../Commons/Icons/book.svg';

import { hasPermissions } from '../Commons/CompanyAuth';

const ProvidersShow = (props) => {
    const { id } = useParams();
    const resource = useResourceContext();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const [providerCode, setProviderCode] = useState('');
    const [providerType, setProviderType] = useState(false);
    const [name, setName] = useState('');
    const [address, setAddress] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [phones, setPhones] = useState('');
    const [nit, setNit] = useState('');
    const [paysIVA, setPaysIVA] = useState(false);
    const [isrWithholding, setIsrWithholding] = useState(false);
    const [checkIssuanceName, setCheckIssuanceName] = useState('');
    const [withholdingAgent, setWithholdingAgent] = useState(false);
    const [acquirer, setAcquirer] = useState(false);
    const [noVatChargeOnFe, setNoVatChargeOnFe] = useState(false);
    const [numericInvoice, setNumericInvoice] = useState(false);
    const [contactPerson, setContactPerson] = useState('');
    const [email, setEmail] = useState('');
    const [bankName, setBankName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [accountName, setAccountName] = useState('');
    const [openAuth, setOpenAuth] = useState(false);
    const [auth, setAuth] = useState(false);
    // Mientras esto es true se muestra el spinner de carga inicial (ver el bloque
    // "initialLoading" en el return): sin este estado la ventana se veia en blanco
    // (solo el breadcrumb) mientras se traian los permisos y el detalle del proveedor.
    const [initialLoading, setInitialLoading] = useState(true);
    const dataProvider = useDataProvider();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        (async () => {
            try {
                const record = await dataProvider.getOne(resource, { id: id });
                const authdata = { data: hasPermissions('Provider', 'read') };
                if (authdata.data.length > 0) {
                    setAuth(authdata.data[0]);
                    setOpenAuth(!authdata.data[0]);
                    const data = record.data;
                    if (authdata.data[0]) {
                        historyTracker.addPath(location.pathname, data.name, 3);

                        setProviderCode(data.providerCode?.toString());
                        setProviderType(data.providerType);
                        setName(data.name);
                        setAddress(data.address);
                        setZipCode(data.zipCode);
                        setPhones(data.phones);
                        setNit(data.nit);
                        setPaysIVA(data.paysIVA);
                        setIsrWithholding(data.isrWithholding);
                        setCheckIssuanceName(data.checkIssuanceName);
                        setWithholdingAgent(data.withholdingAgent);
                        setAcquirer(data.acquirer);
                        setNoVatChargeOnFe(data.noVatChargeOnFe);
                        setNumericInvoice(data.numericInvoice);
                        setContactPerson(data.contactPerson);
                        setEmail(data.email);
                        setBankName(data.bankName);
                        setAccountNumber(data.accountNumber);
                        setAccountName(data.accountName);
                    }
                } else {
                    setAuth(false);
                    setOpenAuth(true)
                }
            }
            catch (error) {
                console.log(error);
            }
            finally {
                setInitialLoading(false);
            }
        })();
    }, [dataProvider, location.pathname, id, resource]);

    const handleRedirectProviderList = () => {
        navigate(`/provider`);
    };

    const [openProviders, setOpenProviders] = useState(true);

    const handleClickOpenProviders = () => {
        setOpenProviders(!openProviders);
    };

    const menus = [{
        icon: <img src={providers} alt="logo" style={Style.MenuLogo} />, name: 'Proveedores',
        open: openProviders,
        openAction: handleClickOpenProviders,
        actions: [
            { icon: <img src={providerList} alt="logo" style={Style.MenuLogo} />, name: 'Listado', onClick: handleRedirectProviderList },
        ]
    }];

    // Accion sobre este proveedor puntual: abre el listado de sus facturas
    // (sp_lista_cbfactura_editable acotado por codigo_proveedor).
    // providerName va tambien como query param (no solo location.state): la pantalla de
    // destino usa <List syncWithLocation>, que reescribe la URL apenas monta y en ese
    // reescritura se pierde el location.state original, asi que la URL es la unica fuente
    // confiable para llevar el dato mas alla del primer render.
    const handleRedirectInvoices = () => {
        navigate({
            pathname: '/provider/invoice',
            search: `?filter=${encodeURIComponent(JSON.stringify({ provider: providerCode }))}&providerName=${encodeURIComponent(name || '')}`,
        }, { state: { providerName: name, providerCode } });
    };

    // Mismo patron que handleRedirectInvoices: el codigo/nombre del proveedor viajan en la
    // propia query string (no solo en location.state) porque ProviderPayableInvoicesList usa
    // <List syncWithLocation>, que reescribe la URL apenas monta y ahi se pierde el state.
    const handleRedirectPayableInvoices = () => {
        navigate({
            pathname: '/provider/invoicetopay',
            search: `?filter=${encodeURIComponent(JSON.stringify({ provider: providerCode }))}&providerName=${encodeURIComponent(name || '')}`,
        }, { state: { providerName: name, providerCode } });
    };

    return (
        <div class="container">
            <BreadCrumbCustom history={historyTracker.getHistory()} />
            {initialLoading ? (
                // Spinner de carga inicial: reutiliza la misma clase "Loading" (index.css) y
                // el mismo CircularProgress que ya se usa en otras pantallas para el
                // guardado, pero aqui cubre la espera de auth + detalle del proveedor, que
                // antes dejaba la pantalla en blanco.
                <div class="Loading" style={{ display: 'block' }}>
                    <CircularProgress size="15rem" />
                </div>
            ) : auth ? (
                <div class="edit">
                    {!isSmall ? (
                        <div class="container">
                            <div class="row">
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!providerType} color="primary" />}
                                        label={<Typography style={Style.Flags}>Tipo Proveedor</Typography>}
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!paysIVA} color="primary" />}
                                        label={<Typography style={Style.Flags}>Paga IVA</Typography>}
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!isrWithholding} color="primary" />}
                                        label={<Typography style={Style.Flags}>ISR Retiene</Typography>}
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!withholdingAgent} color="primary" />}
                                        label={<Typography style={Style.Flags}>Agente Retenedor</Typography>}
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!acquirer} color="primary" />}
                                        label={<Typography style={Style.Flags}>Adquiriente</Typography>}
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!numericInvoice} color="primary" />}
                                        label={<Typography style={Style.Flags}>Factura Numérica</Typography>}
                                    />
                                </div>
                                <div class="col-3">
                                    <FormControlLabel
                                        control={<Switch disabled checked={!!noVatChargeOnFe} color="primary" />}
                                        label={<Typography style={Style.Flags}>Sin IVA x Cobrar en FE</Typography>}
                                    />
                                </div>
                            </div>
                            <div class="row">
                                <InputFieldCustom readOnly value={name} setValue={setName} col="col-6" width="95%" label="Nombre" type="text" />
                                <InputFieldCustom readOnly value={nit} setValue={setNit} col="col-3" width="95%" label="NIT" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom readOnly value={address} setValue={setAddress} col="col-6" width="95%" label="Dirección" type="text" />
                                <InputFieldCustom readOnly value={zipCode} setValue={setZipCode} col="col-3" width="95%" label="Código Postal" type="text" />
                                <InputFieldCustom readOnly value={phones} setValue={setPhones} col="col-3" width="95%" label="Teléfono" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom readOnly value={email} setValue={setEmail} col="col-3" width="95%" label="Correo Electrónico" type="text" />
                                <InputFieldCustom readOnly value={contactPerson} setValue={setContactPerson} col="col-3" width="95%" label="Persona Contacto" type="text" />
                            </div>
                            <div class="row">
                                <InputFieldCustom readOnly value={bankName} setValue={setBankName} col="col-3" width="95%" label="Banco" type="text" />
                                <InputFieldCustom readOnly value={accountNumber} setValue={setAccountNumber} col="col-3" width="95%" label="Número de Cuenta" type="text" />
                                <InputFieldCustom readOnly value={accountName} setValue={setAccountName} col="col-3" width="95%" label="Nombre de Cuenta" type="text" />
                                <InputFieldCustom readOnly value={checkIssuanceName} setValue={setCheckIssuanceName} col="col-3" width="95%" label="Nombre Emisión Cheque" type="text" />
                            </div>
                            <div style={{ marginTop: '2em' }}>
                                <BottomToolBar buttons={[{ auth: auth, action: handleRedirectInvoices, name: 'Por Procesar' }, { auth: auth, action: handleRedirectPayableInvoices, name: 'Por Pagar' }]} menu={<InternalMenu menus={menus} />} />
                            </div>
                        </div>
                    ) : (
                        <div class="container">
                        </div>
                    )}
                </div>) : (<AuthNotification openerror={openAuth} severity={'error'} message={'No posee los permisos para poder interactuar con esta vista'} />)
            }
        </div>
    )
}

export default ProvidersShow;
